module.exports = __webpack_public_path__ + "static/media/01-historia-extraordinaria@2x.067594b3.jpg";